import React from "react";
import styled from "styled-components";

import NoBusInfo from "../layout/NoBusInfo";
import TimePointsCircle from "./TimePointsCircle";
import variableColors from "../_App.module.scss";
import TimePointsCustomProgressBar from "./TimePointsCustomProgressBar";
import TopInfoComponent from "../layout/TopInfoComponent";
import { ComponentContainer } from "./Settings";
import useNetworkStatus from "../services/useNetworkStatus";
import useCurrentTripData from "../services/useCurrentTripData";

const { textColor, appBackgroundColor, secondaryColor } = variableColors;

const TimePointsContainer = styled(ComponentContainer)`
  margin-left: auto;
  margin-right: auto;
  max-width: 1024px;
  background-color: ${appBackgroundColor};
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  align-content: center;
  height: 100%;
  gap: 0.5rem;
`;

const HeadSignP = styled.p`
  font-size: 1.2rem;
  margin-bottom: 0;
`;

const TimePoints = (): JSX.Element => {
  const { isMobile } = useNetworkStatus();

  //* Custom Hook
  const { currentData, currentSegmentPercentage, progressBarStops } = useCurrentTripData();

  return (
    <React.Fragment>
      <TimePointsContainer $isMobile={isMobile}>
        {currentData ? (
          <React.Fragment>
            <TopInfoComponent fontSize="90%" />

            <TimePointsCircle
              iconColor={currentData?.iconColor || secondaryColor}
              textColor={textColor}
              addedStatus2={currentData?.addedStatus2 || ""}
              startTime={currentData?.startTime}
              endTime={currentData?.endTime}
            />

            <HeadSignP>
              To: <span className="span_bold">{currentData.headsign}</span>
            </HeadSignP>

            {progressBarStops && currentSegmentPercentage ? (
              <TimePointsCustomProgressBar
                bgColor={currentData?.iconColor || secondaryColor}
                textColor={textColor}
                progressBarStops={progressBarStops}
                percent={currentSegmentPercentage}
              />
            ) : null}
          </React.Fragment>
        ) : (
          <NoBusInfo />
        )}
      </TimePointsContainer>
    </React.Fragment>
  );
};

export default TimePoints;
